import { useLocation } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingCTA from "./FloatingCTA";
import PageBanner from "./PageBanner";

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  const [isTransitioning, setIsTransitioning] = useState(false);
  const prevPath = useRef(location.pathname);

  // Smooth scroll reset on route change with subtle fade transition
  useEffect(() => {
    if (location.pathname !== prevPath.current && !isAdmin) {
      setIsTransitioning(true);
      const timer = setTimeout(() => {
        window.scrollTo(0, 0);
        setIsTransitioning(false);
      }, 100);
      prevPath.current = location.pathname;
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
    prevPath.current = location.pathname;
  }, [location.pathname, isAdmin]);

  if (isAdmin) {
    return <>{children}</>;
  }

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar />
      <PageBanner />
      <main
        className={`flex-1 transition-opacity duration-100 ${
          isTransitioning ? 'opacity-70' : 'opacity-100'
        }`}
      >
        {children}
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}
